import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { StarsModule } from './../stars/stars.module';
import { HistoricComponent } from './historic.component';


@NgModule({
  entryComponents: [
    HistoricComponent
  ],
  imports: [
    FuseSharedModule,
    MatButtonModule,
    StarsModule,
    TranslateModule
  ],
  declarations: [
    HistoricComponent
  ],
  exports: [
    HistoricComponent
  ]
})
export class HistoricModule { }
